module.exports = __webpack_public_path__ + "assets/img/cus12.ff07ae53.jpg";